import { VcfDomain } from 'pcs-domain';
import { IWldInputProductConfig } from "../wld-input-configuration-factory.service";

export class VCF_5_2_1_STANDARD_MANAGEMENT implements IWldInputProductConfig{
    configuration: VcfDomain.Group={
            "groupId": "managmentDomainComponents",
            "groupName": "Management Domain Components",
            "groupLabel": "Management Domain component sizes are automatically selected based on workload sizes. You can accept these defaults by clicking 'NEXT' to receive recommendations.",
            "subGroups": [
                {
                        "id": 0,
                        "subGroupId": "SDDC-MANAGER",
                        "subGroupName": "Deploy SDDC Manager",
                        "label": "SDDC Manager has only one-size and selected by default.",
                        "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-5-2-and-earlier/5-2/vcf-design-5-2/vcf-sddc-manager-design.html#GUID-CC023839-B188-4F2D-B42E-237BB00B4A6A-en",
                        "documentLabel": "Learn More",
                        "isEnabled": true,
                        "isRequired": true,
                        "inputs": [
                            {
                                "id": "sizing",
                                "type": "COMPONENT_DROPDOWN",
                                "label": "Pick the appropriate size to deploy SDDC Manager *",
                                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vcf/vcf-5-2-and-earlier/5-2/vcf-design-5-2/vcf-sddc-manager-design.html#GUID-CC023839-B188-4F2D-B42E-237BB00B4A6A-en",
                                "documentLabel": "Learn More",
                                "isRequired": true,
                                "isEnabled": true,
                                "default": "FIXED",
                                "minNumberOfVms": 0,
                                "predicate": {},
                                "options": [],
                                "componentSizing": [
                                    {
                                        "id": "FIXED",
                                        "overheads": [
                                            {
                                                "id": "SDDC-MANAGER",
                                                "name": "One-Size",
                                                "resources": {}
                                            },
                                        ]
                                    }
                                ]
                            }
                        ]
                },
                {
                        "id": 0,
                        "subGroupId": "VCENTER",
                        "subGroupName": "Deploy VMware vCenter Server",
                        "label": "You can choose the size of vCenter for the Management Domain. We will provide you with the sizing recommendation.",
                        "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vsphere/vsphere/8-0/release-notes/vcenter-server-update-and-patch-release-notes/vsphere-vcenter-server-80u3c-release-notes.html",
                        "documentLabel": "Learn More",
                        "isEnabled": true,
                        "isRequired": true,
                        "inputs": [
                            {
                                "id": "sizing",
                                "type": "COMPONENT_DROPDOWN",
                                "label": "Pick the appropriate size to deploy vCenter *",
                                "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/vsphere/vsphere/8-0/release-notes/vcenter-server-update-and-patch-release-notes/vsphere-vcenter-server-80u3c-release-notes.html",
                                "documentLabel": "Learn More",
                                "isRequired": true,
                                "isEnabled": true,
                                "default": "SMALL",
                                "minNumberOfVms": 0,
                                "predicate": {},
                                "options": [],
                                "componentSizing": [
                                    {
                                        "id": "TINY",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "SMALL",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "MEDIUM",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    },
                                    {
                                        "id": "X-LARGE",
                                        "overheads": [
                                            {
                                                "id":"",
                                                "name": "",
                                                "resources": {}
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                },
                {
                    "id": 0,
                    "subGroupId": "NSX-MANAGER",
                    "subGroupName": "Deploy VMware NSX Manager",
                    "label": "You can have a dedicated NSX manager for the Management domain.",
                    "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/nsx/vmware-nsx/4-2/installation-guide.html",
                    "documentLabel": "Learn More",
                    "isEnabled": true,
                    "isRequired": true,
                    "inputs": [
                        {
                            "id": "sizing",
                            "type": "COMPONENT_DROPDOWN",
                            "label": "Pick the appropriate size to deploy NSX Manager *",
                            "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/nsx/vmware-nsx/4-2/installation-guide.html",
                            "documentLabel": "Learn More",
                            "isRequired": true,
                            "isEnabled": true,
                            "default": "SMALL",
                            "minNumberOfVms": 0,
                            "predicate": {},
                            "options": [],
                            "componentSizing": [
                                {
                                    "id": "MEDIUM",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "resources": {}
                                        }
                                    ]
                                },
                                {
                                    "id": "LARGE",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "resources": {}
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": 0,
                    "subGroupId": "NSX-EDGE",
                    "subGroupName": "Deploy VMware NSX Edge",
                    "label": "You can choose NSX Edge for the Management Domain based on your throughput requirement.",
                    "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/nsx/vmware-nsx/4-2/installation-guide/installing-nsx-edge.html",
                    "documentLabel": "Learn More",
                    "isEnabled": false,
                    "isRequired": false,
                    "inputs": [
                        {
                            "id": "sizing",
                            "type": "COMPONENT_DROPDOWN",
                            "label": "Pick the appropriate size to deploy NSX Edge *",
                            "isRequired": false,
                            "isEnabled": false,
                            "default": "MEDIUM",
                            "minNumberOfVms": 0,
                            "predicate": {},
                            "options": [],
                            "componentSizing": [
                                {
                                    "id": "SMALL",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "label": "Suggested when total throughput requirement is <2 Gbps",
                                            "resources": {}
                                        }
                                    ]
                                },
                                {
                                    "id": "MEDIUM",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "label": "Suggested when total throughput requirement is <2 Gbps",
                                            "resources": {}
                                        }
                                    ]
                                },
                                {
                                    "id": "LARGE",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "label": "Suggested when total throughput requirement is 2-10 Gbps",
                                            "resources": {}
                                        }
                                    ]
                                },
                                {
                                    "id": "X-LARGE",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "label": "Suggested when total throughput requirement is >10 Gbps",
                                            "resources": {}
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "id": 0,
                    "subGroupId": "ARIA-SUITE",
                    "subGroupName": "Deploy Aria Suite",
                    "label": "This will include Aria Operations Enterprise, Aria Operations for Logs, Aria Automation Enterprise, VMware Aria Suite Lifecycle Manager and Workspace One Access",
                    "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/aria/aria-operations/8-18/getting-started-with-vmware-aria-operations-8-18/installing-vrealize-operations-manager.html",
                    "documentLabel": "Learn More",
                    "isEnabled": false,
                    "isRequired": false,
                    "inputs": [
                        {
                            "id": "sizing",
                            "type": "MULTI_COMPONENT_DROPDOWN",
                            "label": "Pick the appropriate size to deploy Aria Suite *",
                            "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/aria/aria-operations/8-18/getting-started-with-vmware-aria-operations-8-18/installing-vrealize-operations-manager.html",
                            "documentLabel": "Learn More",
                            "isRequired": false,
                            "isEnabled": false,
                            "default": "MEDIUM",
                            "minNumberOfVms": 0,
                            "predicate": {},
                            "options": [],
                            "componentId": "ARIA-SUITE",
                            "componentSizing": [
                                {
                                    "id": "MEDIUM",
                                    "overheads": [
                                        { "id": "vRSLCM", "name": "VMware Aria Suite Lifecycle Manager", "resources": {} },
                                        { "id": "WORKSPACE-ONE-ACCESS", "name": "Workspace One Access", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-MANAGER", "name": "Aria Operations Manager/Cluster", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-LOGS", "name": "Aria Operations for Logs", "resources": {} },
                                        { "id": "ARIA-AUTOMATION", "name": "Aria Automation", "resources": {} }
                                    ]
                                },
                                {
                                    "id": "LARGE",
                                    "overheads": [
                                        { "id": "vRSLCM", "name": "VMware Aria Suite Lifecycle Manager", "resources": {} },
                                        { "id": "WORKSPACE-ONE-ACCESS", "name": "Workspace One Access", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-MANAGER", "name": "Aria Operations Manager/Cluster", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-LOGS", "name": "Aria Operations for Logs", "resources": {} },
                                        { "id": "ARIA-AUTOMATION", "name": "Aria Automation", "resources": {} }
                                    ]
                                },
                                {
                                    "id": "X-LARGE",
                                    "overheads": [
                                        { "id": "vRSLCM", "name": "VMware Aria Suite Lifecycle Manager", "resources": {} },
                                        { "id": "WORKSPACE-ONE-ACCESS", "name": "Workspace One Access", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-MANAGER", "name": "Aria Operations Manager/Cluster", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-LOGS", "name": "Aria Operations for Logs", "resources": {} },
                                        { "id": "ARIA-AUTOMATION", "name": "Aria Automation", "resources": {} }
                                    ]
                                },
                                {
                                    "id": "2X-LARGE",
                                    "overheads": [
                                        { "id": "vRSLCM", "name": "VMware Aria Suite Lifecycle Manager", "resources": {} },
                                        { "id": "WORKSPACE-ONE-ACCESS", "name": "Workspace One Access", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-MANAGER", "name": "Aria Operations Manager/Cluster", "resources": {} },
                                        { "id": "ARIA-OPERATIONS-LOGS", "name": "Aria Operations for Logs", "resources": {} },
                                        { "id": "ARIA-AUTOMATION", "name": "Aria Automation", "resources": {} }
                                    ]
                                },
                            ]
                        }
                    ]
                },
                {
                    "id": 0,
                    "subGroupId": "AON",
                    "subGroupName": "Deploy Aria Operations Network",
                    "label": "This will include Aria Operations Network Platform VMs and Collector VMs",
                    "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/aria/aria-operations-for-networks/6-13/vrealize-network-insight-installation-6-13/installation.html",
                    "documentLabel": "Learn More",
                    "isEnabled": false,
                    "isRequired": false,
                    "inputs": [
                        {
                            "id": "aonPlatformSize",
                            "type": "COMPONENT_DROPDOWN",
                            "label": "Pick the appropriate size for Platform VMs *",
                            "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/aria/aria-operations-for-networks/6-13/vrealize-network-insight-installation-6-13/installation.html",
                            "documentLabel": "Learn More",
                            "isRequired": false,
                            "isEnabled": false,
                            "default": "MEDIUM",
                            "minNumberOfVms": 0,
                            "predicate": {},
                            "options": [],
                            "componentId": "AON-PLATFORM",
                            "componentSizing": [
                                {
                                    "id": "MEDIUM",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "resources": {}
                                        }
                                    ]
                                },
                                {
                                    "id": "LARGE",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "resources": {}
                                        }
                                    ]
                                },
                                {
                                    "id": "X-LARGE",
                                    "overheads": [
                                        {
                                            "id":"",
                                            "name": "",
                                            "resources": {}
                                        }
                                    ]
                                },
                            ]
                        },
                        {
                            "id": "aonCollectorSize",
                            "type": "COMPONENT_DROPDOWN",
                            "label": "Pick the appropriate size for Collector VMs *",
                            "documentLink": "https://techdocs.broadcom.com/us/en/vmware-cis/aria/aria-operations-for-networks/6-13/vrealize-network-insight-installation-6-13/installation.html",
                            "documentLabel": "Learn More",
                            "isRequired": false,
                            "isEnabled": false,
                            "default": "MEDIUM",
                            "minNumberOfVms": 0,
                            "predicate": {},
                            "options": [],
                            "componentId": "AON-COLLECTOR",
                            "componentSizing": [
                                { "id": "MEDIUM", "overheads": [ { "id": "", "name": "", "resources": {} } ] },
                                { "id": "LARGE",  "overheads": [ { "id": "", "name": "", "resources": {} } ] },
                                { "id": "X-LARGE","overheads": [ { "id": "", "name": "", "resources": {} } ] },
                                { "id": "2X-LARGE","overheads": [ { "id": "", "name": "", "resources": {} } ] }
                            ]
                        }
                    ]
                }
            ]
        };
    getProductInfo(): string {
        throw new Error("Method not implemented.");
    }
    getDatabaseConnectionString(): string {
        throw new Error("Method not implemented.");
    }
    getApiEndpoint(): string {
        throw new Error("Method not implemented.");
    }
    getDeploymentStrategy(): string {
        throw new Error("Method not implemented.");
    }

}
